import { festProvider } from './fest'
import { deposelProvider } from './deposel'
import { soyalpProvider } from './soyalp'
import { gursoyProvider } from './gursoy'
import type { CargoBrokerType, CargoProvider } from './types'

export * from './types'
export * from './shipment'
export * from './problem'
export * from './shipment-match'
export { festProvider } from './fest'
export { deposelProvider } from './deposel'
export { soyalpProvider } from './soyalp'
export { gursoyProvider } from './gursoy'
export {
  toAmountString,
  buildConsignmentForm,
  createWebpostmanProvider,
  setCargoRateLimiter,
  CargoRateLimitedError,
  isCargoRateLimitedError,
  trackingRecordFromRow,
} from './webpostman'
export type { CargoRateLimiter, CargoRateLimitReporter } from './webpostman'
export { buildCargoBarcode, stripLeadingZeros } from './barcode'

/** Aracı kargo sağlayıcı kayıt defteri — yeni aracı firmalar buraya eklenir. */
export const CARGO_PROVIDERS: Record<CargoBrokerType, CargoProvider> = {
  fest: festProvider,
  deposel: deposelProvider,
  soyalp: soyalpProvider,
  gursoy: gursoyProvider,
}

export function getCargoProvider(type: string): CargoProvider | null {
  return (CARGO_PROVIDERS as Record<string, CargoProvider>)[type] ?? null
}

/** Desteklenen aracı kargo firması tipleri. */
export const SUPPORTED_CARGO_BROKERS: CargoBrokerType[] = ['fest', 'deposel', 'soyalp', 'gursoy']

/** Aracı firma tipi → görünen ad (UI için). */
export const CARGO_BROKER_LABELS: Record<CargoBrokerType, string> = {
  fest: 'FEST Danışmanlık',
  deposel: 'Deposer',
  soyalp: 'Soyalp Kargo',
  gursoy: 'Gürsoy Kargo',
}
